<template>
    <header class="m-single-header" v-if="post">
        <!-- 标题 -->
        <div class="m-single-title">
            <span class="u-title u-sub-block" :href="url" :title="title">
                <i class="u-original" v-if="isOriginal">原创</i>
                <i class="u-private" v-if="post.post_status != 'publish' || !!~~post.visible">
                    <i class="el-icon-lock" v-if="post.post_status == 'draft' || post.post_status == 'pending' || !!~~post.visible" style="color:#fb9b24"></i>
                    <i class="el-icon-delete" v-if="post.post_status == 'dustbin'" style="color:#c00"></i>
                </i>
                <span class="u-title-text">{{ title }}</span>
            </span>
        </div>

        <!-- 信息 -->
        <div class="m-single-info">
            <!-- 用户名 -->
            <div class="u-author u-sub-block">
                <i class="u-author-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" width="12" height="16" aria-hidden="true" fill="#444" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" d="M12 14.002a.998.998 0 01-.998.998H1.001A1 1 0 010 13.999V13c0-2.633 4-4 4-4s.229-.409 0-1c-.841-.62-.944-1.59-1-4 .173-2.413 1.867-3 3-3s2.827.586 3 3c-.056 2.41-.159 3.38-1 4-.229.59 0 1 0 1s4 1.367 4 4v1.002z"/></svg>
                </i>
                <a class="u-name" :href="author_link">{{ author_name }}</a>
            </div>

            <!-- 自定义字段 -->
            <!-- <template v-if="metas && metas.length">
            <div class="u-meta u-sub-block" v-for="(meta_value,meta_key) in metas" :key="meta_key">
                <em class="u-label">{{meta_key}}</em>
                <span class="u-value">{{meta_value}}</span>
            </div>
            </template> -->
            <slot></slot>

            <!-- 客户端 -->
            <div class="u-meta u-sub-block">
                <em class="u-label">适用客户端</em>
                <span class="u-value u-client" :class="client">{{ showClientLabel(client) }}</span>
            </div>

            <!-- 发布日期 -->
            <span class="u-podate u-sub-block"  :title="'发布日期:' + post_time">
                <i class="u-icon-podate">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="#6a737d" viewBox="0 0 485.2 485.2" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M60.7 75.8V15.2C60.7 6.8 67.4 0 75.8 0 84.2 0 91 6.8 91 15.2v60.7C91 84.2 84.2 91 75.8 91c-8.4 0-15.1-6.8-15.1-15.2zM318.4 91c8.4 0 15.2-6.8 15.2-15.2V15.2c0-8.4-6.8-15.2-15.2-15.2-8.4 0-15.2 6.8-15.2 15.2v60.7c.1 8.3 6.8 15.1 15.2 15.1zM60.7 182h60.7v60.7H60.7zM60.7 272.9h60.7v60.7H60.7zM151.6 182h60.7v60.7h-60.7zM151.6 272.9h60.7v60.7h-60.7z"/><path d="M30 361.2v-210h334c.2 70.7.4 141.4.7 212.1 9.8 0 19.6-.1 29.3-.1V93.6c0-18.5-14.5-33.4-32.5-33.4H349v15.2c0 16.7-13.7 30.3-30.5 30.3S288 92.1 288 75.4V60.2H106v15.2c0 16.7-13.7 30.3-30.5 30.3S45 92.1 45 75.4V60.2H32.5c-18 0-32.5 15-32.5 33.4v267.2c0 9.2 3.6 17.5 9.5 23.6 7.8 8.1 18.5 9.3 23 9.8 22.1 2.4 165.3 2.9 361.5 1v-32c-120.5.3-241 .7-361.5 1-.8-1-1.7-2-2.5-3z"/><path d="M242.6 182h60.6v60.7h-60.6zM242.6 272.9h60.7v60.7h-60.7z"/></svg>
                </i>
                <time>{{ post_date }}</time>
            </span>

            <!-- 最后更新 -->
            <span class="u-modate u-sub-block" :title="'最后更新:' + update_time">
                <i class="u-icon-modate">
                    <svg xmlns="http://www.w3.org/2000/svg" width="485.213" height="485.212" viewBox="0 0 485.213 485.212" fill="#555" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M60.652 75.816V15.163C60.652 6.781 67.433 0 75.817 0c8.38 0 15.161 6.781 15.161 15.163v60.653c0 8.38-6.781 15.161-15.161 15.161-8.384.001-15.165-6.781-15.165-15.161zm257.772 15.162c8.378 0 15.163-6.781 15.163-15.161V15.163C333.587 6.781 326.802 0 318.424 0c-8.382 0-15.168 6.781-15.168 15.163v60.653c0 8.38 6.786 15.162 15.168 15.162zm166.788 272.928c0 66.996-54.312 121.307-121.303 121.307-66.986 0-121.302-54.311-121.302-121.307 0-66.986 54.315-121.3 121.302-121.3 66.991 0 121.303 54.313 121.303 121.3zm-30.322 0c0-50.161-40.81-90.976-90.98-90.976-50.166 0-90.976 40.814-90.976 90.976 0 50.171 40.81 90.98 90.976 90.98 50.17 0 90.98-40.809 90.98-90.98zM121.305 181.955H60.652v60.651h60.653v-60.651zM60.652 333.584h60.653V272.93H60.652v60.654zm90.977-90.978h60.654v-60.651h-60.654v60.651zm0 90.978h60.654V272.93h-60.654v60.654zM30.328 360.891V151.628H363.91v60.653h30.327V94c0-18.421-14.692-33.349-32.843-33.349h-12.647v15.166c0 16.701-13.596 30.325-30.322 30.325-16.731 0-30.326-13.624-30.326-30.325V60.651H106.14v15.166c0 16.701-13.593 30.325-30.322 30.325-16.733 0-30.327-13.624-30.327-30.325V60.651H32.859C14.707 60.651.001 75.579.001 94v266.892c0 18.36 14.706 33.346 32.858 33.346h179.424v-30.331H32.859c-1.374-.001-2.531-1.42-2.531-3.016zm272.928-118.285v-60.651h-60.648v60.651h60.648zm106.143 121.3h-45.49v-45.49c0-8.377-6.781-15.158-15.163-15.158s-15.159 6.781-15.159 15.158v60.658c0 8.378 6.777 15.163 15.159 15.163h60.653c8.382 0 15.163-6.785 15.163-15.163 0-8.382-6.781-15.168-15.163-15.168z"/></svg>
                </i>
                <time>{{ update_date }}</time>
            </span>

            <!-- 查看次数 -->
            <span class="u-views u-sub-block">
                <i class="el-icon-view"></i>
                {{ views }}
            </span>

            <!-- 编辑 -->
            <a class="u-edit u-sub-block" :href="edit_link" v-if="canEdit">
                <i class="u-icon-edit el-icon-edit-outline"></i>
                <span>编辑</span>
            </a>
        </div>
    </header>
</template>

<script>
import { __Root,__clients } from "@jx3box/jx3box-common/data/jx3box.json";
import { showDate, showTime } from "@jx3box/jx3box-common/js/moment";
import { editLink, authorLink } from "@jx3box/jx3box-common/js/utils.js";
import User from "@jx3box/jx3box-common/js/user.js";
export default {
    name: "single-header",
    props: ["post", "stat"],
    data: function() {
        return {};
    },
    computed: {
        url: function() {
            return location.href;
        },
        isOriginal: function() {
            return !!~~this.post?.original;
        },
        title: function() {
            return this.post?.post_title || "无标题";
        },
        author_link: function() {
            return authorLink(this.post?.post_author);
        },
        author_name: function() {
            return this.post?.author_info?.display_name || "匿名";
        },
        post_date: function() {
            return showDate(new Date(this.post?.post_date));
        },
        update_date: function() {
            return showDate(new Date(this.post?.post_modified));
        },
        post_time: function() {
            return showTime(new Date(this.post?.post_date));
        },
        update_time: function() {
            return showTime(new Date(this.post?.post_modified));
        },
        views: function() {
            return this.stat?.views || "-";
        },
        edit_link: function() {
            return editLink(this.post?.post_type, this.post?.ID);
        },
        canEdit: function() {
            return this.post?.post_author == User.getInfo().uid || User.isEditor();
        },
        client: function() {
            return this.post?.client || "std";
        },
    },
    methods: {
        showClientLabel: function(val) {
            return __clients[val];
        },
    },
    mounted: function() {},
};
</script>

<style lang="less">
.m-single-header {
    padding-top: 20px;
    padding-bottom: 20px;
    // padding-right: 280px;
    .pr;
    .u-sub-block {
        .dbi;
        .y(top);
    }
}
@media screen and (max-width: @phone) {
    .m-single-header {
        padding-right: 0;
    }
}
@media print {
    .m-single-header {
        padding-right: 0;
    }
}

.m-single-title {
    .fz(32px);
    padding: 1px 0;

    .u-title {
        color: @color;
        // &:hover {
        //     color: @primary;
        // }
        letter-spacing: 0.5px;
        font-weight: 300;
        .db;
        .nobreak;
    }
    .u-author {
        .pr;
    }

    .u-original {
        background-color: #6f42c1;
        color: #fff;
        .fz(14px, 20px);
        font-style: normal;
        font-weight: normal;
        padding: 2px 5px;
        .mr(5px);
        // .fl;
    }

    .u-private {
        .y(-2px);
        margin-right: 5px;
        color: #111;
    }
}
@media screen and (max-width: @phone) {
    .m-single-title {
        .fz(1rem, 1.8);
        .u-title {
            word-break: break-all;
            white-space: normal;
            font-weight: normal;
        }
    }
}
@media print {
    .m-single-title {
        .x;
    }
}

.m-single-info {
    margin-top: 10px;
    .clearfix;
    .fz(12px, 20px);
    color: #666;

    @origin: #0eb7ce;
    @std: #f0b400;
    @all: #a26ef7;

    .u-client {
        // .fl;
        font-style: normal;
        .fz(12px);
        padding: 0px 5px;
        .r(3px);
        // .mr(10px);

        &.std {
            border: 1px solid @std;
            color: @std;
        }

        &.origin {
            border: 1px solid @origin;
            color: @origin;
        }

        &.all {
            border: 1px solid @all;
            color: @all;
        }
    }

    * {
        .dbi;
    }

    svg {
        fill: #666;
        .size(16px);
        .y;
        .mr(3px);
    }

    .u-sub-block {
        .mr(15px);
        .fl;
    }

    .u-author {
        a:hover {
            box-shadow: 0 1px 0 @color-link;
        }
        i {
            .pr;
            top: -2px;
        }
    }

    .u-label {
        .mr(5px);
        background-color: #eee;
        padding: 0 5px;
        .r(2px);
        font-style: normal;
    }
    .u-value {
    }

    .u-views {
        i {
            .fz(15px);
            .y;
        }
    }

    .u-edit {
        i {
            &:before {
                font-size: 16px;
            }
            .pr;
            top: 2px;
            .mr(3px);
        }
        &:hover {
            box-shadow: 0 1px 0 @color-link;
        }
    }
}
@media screen and (max-width: @ipad) {
    .m-single-info {
        .u-meta {
            .none;
        }
    }
}
@media screen and (max-width: @phone) {
    .m-single-info {
        .u-podate {
            .none;
        }
    }
}
@media print {
    .m-single-info {
        .u-meta,
        .u-views,
        .u-edit {
            .none;
        }
        .x;
        .u-sub-block {
            float: none;
        }
        .u-name {
            color: @color;
        }
    }
}
</style>
